/**
 * Aliangé Skin Analysis - Bundled Script
 * structure: Config -> Engine -> UI -> Init
 */

(function () {
    'use strict';

    // --- 1. CONFIGURATION ---
    const QUIZ_CONFIG = {
        settings: {
            intro_heading: "Expert Skin Analysis",
            intro_subheading: "Identify your unique skin profile and receive a prescribed Aliangé protocol.",
        },
        questions: [
            {
                id: "baseline_skin", // Q1
                text: "By midday, how does your skin most consistently feel without makeup?",
                type: "single",
                options: [
                    { id: "oily_all", text: "Oily across most of the face", weights: { acne: 2, barrier: 1 } },
                    { id: "oily_t", text: "Oily through the T-zone with drier cheeks", weights: { barrier: 2 } },
                    { id: "balanced", text: "Comfortable and balanced", weights: { tolerance: 1 } },
                    { id: "tight_dry", text: "Tight or dry, particularly after cleansing", weights: { barrier: 2, ageing: 1 } },
                    { id: "very_dry", text: "Very dry, rough, or prone to flaking", weights: { barrier: 3, sensitivity: 1 } }
                ]
            },
            {
                id: "primary_priority", // Q2
                text: "If one concern were to be medically prioritised, which would it be?",
                type: "single",
                options: [
                    { id: "breakouts", text: "Active breakouts or congestion", weights: { acne: 3 } },
                    { id: "redness", text: "Persistent redness, irritation, or flushing", weights: { sensitivity: 3, barrier: 2 } },
                    { id: "ageing", text: "Fine lines, loss of firmness, or visible ageing", weights: { ageing: 3 } },
                    { id: "pigment", text: "Dark spots, pigmentation, or uneven tone", weights: { pigment: 3 } },
                    { id: "dullness", text: "General dullness or tired appearance", weights: { ageing: 1, pigment: 1 } }
                ]
            },
            {
                id: "tolerance_reactivity", // Q3
                text: "How does your skin typically respond to active ingredients (e.g. retinoids, acids, vitamin C)?",
                type: "single",
                options: [
                    { id: "tolerates_most", text: "My skin tolerates most actives without issue", weights: { tolerance: 3 } },
                    { id: "mild_tingle", text: "Mild tingling initially, settles quickly", weights: { tolerance: 1 } },
                    { id: "red_itchy", text: "Easily becomes red, itchy, or uncomfortable", weights: { sensitivity: 2 } },
                    { id: "reacts_quickly", text: "Reacts quickly — I avoid actives and keep routines minimal", weights: { sensitivity: 3, tolerance: -3 } }
                ]
            },
            {
                id: "barrier_integrity", // Q4
                text: "After cleansing, does your skin ever feel hot, sting, or appear visibly red?",
                type: "single",
                options: [
                    { id: "never", text: "No, never", weights: { barrier: 0 } },
                    { id: "occasionally", text: "Occasionally, after harsh products", weights: { barrier: 1 } },
                    { id: "frequently", text: "Frequently or daily", weights: { barrier: 3, sensitivity: 3 } }
                ]
            },
            {
                id: "structural_ageing", // Q5
                text: "Which changes are you beginning to notice?",
                type: "single",
                options: [
                    { id: "deep_lines", text: "Deepening smile lines or crow’s feet", weights: { ageing: 2 } },
                    { id: "volume_loss", text: "Loss of volume or firmness", weights: { ageing: 3 } },
                    { id: "texture", text: "Rough texture or enlarged pores", weights: { ageing: 1, barrier: 1 } },
                    { id: "fine_lines", text: "A few fine lines only", weights: { ageing: 1 } },
                    { id: "none", text: "None of the above", weights: { ageing: 0 } }
                ]
            },
            {
                id: "congestion_pattern", // Q6
                text: "How frequently do you experience breakouts?",
                type: "single",
                options: [
                    { id: "rarely", text: "Rarely or never", weights: { acne: 0 } },
                    { id: "hormonal", text: "Occasional hormonal breakouts (jaw/chin)", weights: { acne: 1 } },
                    { id: "ongoing", text: "Ongoing blackheads or congestion", weights: { acne: 2 } },
                    { id: "frequent", text: "Frequent, inflamed lesions", weights: { acne: 3, sensitivity: 1 } }
                ]
            },
            {
                id: "pigmentation", // Q7
                text: "Do you have visible pigmentation concerns?",
                type: "single",
                options: [
                    { id: "stubborn", text: "Stubborn dark patches or melasma", weights: { pigment: 3 } },
                    { id: "mild", text: "Mild sun spots or freckling", weights: { pigment: 1 } },
                    { id: "even", text: "Overall tone is even", weights: { pigment: 0 } }
                ]
            },
            {
                id: "environment", // Q8
                text: "Your daily environment is best described as:",
                type: "single",
                options: [
                    { id: "indoors", text: "Mostly indoors / controlled", weights: { env: 0 } },
                    { id: "urban", text: "Urban / polluted", weights: { env: 2 } },
                    { id: "outdoors", text: "Outdoor / high sun exposure", weights: { env: 2, pigment: 1 } }
                ]
            }
        ],
        protocols: [
            {
                id: "essential",
                title: "Essential Protocol",
                description: "Prescribed based on your skin assessment to restore barrier integrity and reduce reactivity.",
                price: 180,
                handle: "essential-protocol-bundle"
            },
            {
                id: "the_protocol",
                title: "The Protocol",
                description: "Prescribed based on your skin assessment. A comprehensive system to correct multi-factor signs of ageing and barrier compromise.",
                price: 320,
                handle: "the-protocol-bundle"
            },
            {
                id: "pm_protocol",
                title: "PM Protocol",
                description: "Prescribed based on your skin assessment. Focused advanced regeneration for significant textural and ageing concerns.",
                price: 240,
                handle: "pm-protocol-bundle"
            },
            {
                id: "anti_ageing",
                title: "Anti-Ageing Protocol",
                description: "Prescribed based on your skin assessment. Targeted correction for fine lines, firmness, and elasticity.",
                price: 260,
                handle: "anti-ageing-bundle"
            },
            {
                id: "acne",
                title: "Acne Protocol",
                description: "Prescribed based on your skin assessment. Clarifying care to decongest pores and balance oil production.",
                price: 195,
                handle: "acne-protocol-bundle"
            },
            {
                id: "am_protocol",
                title: "AM Protocol",
                description: "Prescribed based on your skin assessment. Daily defense and protection against environmental stressors.",
                price: 160,
                handle: "am-protocol-bundle"
            }
        ]
    };

    // --- 2. LOGIC ENGINE ---
    class QuizEngine {
        constructor(config) {
            this.config = config;
            this.currentStep = 0;
            this.answers = {}; // Map of questionId -> selectedOptionId
            this.scores = {
                barrier: 0,
                inflammation: 0,
                pigment: 0,
                ageing: 0,
                acne: 0,
                sensitivity: 0,
                tolerance: 0,
                env: 0
            };
        }

        get totalSteps() {
            return this.config.questions.length;
        }

        getCurrentQuestion() {
            return this.config.questions[this.currentStep];
        }

        answerQuestion(questionId, optionId) {
            this.answers[questionId] = optionId;
        }

        nextStep() {
            if (this.currentStep < this.totalSteps) {
                this.currentStep++;
                return true;
            }
            return false;
        }

        prevStep() {
            if (this.currentStep > 0) {
                this.currentStep--;
                return true;
            }
            return false;
        }

        calculateScores() {
            // Reset scores
            for (const key in this.scores) {
                this.scores[key] = 0;
            }

            // Iterate through answers
            for (const [qId, optionId] of Object.entries(this.answers)) {
                const question = this.config.questions.find(q => q.id === qId);
                if (!question) continue;

                const selectedOption = question.options.find(o => o.id === optionId);
                if (selectedOption && selectedOption.weights) {
                    for (const [category, value] of Object.entries(selectedOption.weights)) {
                        if (this.scores[category] !== undefined) {
                            this.scores[category] += value;
                        }
                    }
                }
            }
            return this.scores;
        }

        determineResult() {
            const s = this.calculateScores();

            // Helper: Count how many domains are significant (>= 2)
            // Domains: Ageing, Pigment, Acne
            const highConcerns = [s.ageing, s.pigment, s.acne].filter(val => val >= 2).length;

            // --- 1. Essential Protocol (Safety Override) ---
            // Trigger: Sensitivity >= 4 OR Barrier >= 5
            if (s.sensitivity >= 4 || s.barrier >= 5) {
                return this.getProtocol("essential");
            }

            // --- 2. The Protocol (Comprehensive Correction) ---
            // Trigger: At least 2 concern domains >= 2 AND Sensitivity < 3 AND Barrier >= 2
            if (highConcerns >= 2 && s.sensitivity < 3 && s.barrier >= 2) {
                return this.getProtocol("the_protocol");
            }

            // --- 3. PM Protocol (Advanced Regeneration) ---
            // Trigger: Ageing >= 4 AND Acne <= 1 AND Sensitivity < 3 AND Barrier >= 2
            if (s.ageing >= 4 && s.acne <= 1 && s.sensitivity < 3 && s.barrier >= 2) {
                return this.getProtocol("pm_protocol");
            }

            // --- 4. Anti-Ageing Protocol (Targeted) ---
            // Trigger: Ageing >= 3 AND Sensitivity < 3
            if (s.ageing >= 3 && s.sensitivity < 3) {
                return this.getProtocol("anti_ageing");
            }

            // --- 5. Acne Protocol ---
            // Trigger: Acne >= 4 AND Sensitivity < 3
            // (If Sensitivity was >= 3, they would likely hit Essential or be downgraded here logic-wise, 
            // but strict rule says "if sens >= 3 -> downgrade", handled by Priority 1 check mostly).
            if (s.acne >= 4 && s.sensitivity < 3) {
                return this.getProtocol("acne");
            }

            // --- 6. AM Protocol (Preventative / Environmental) ---
            // Trigger: Env >= 2 AND Ageing < 3 AND Acne < 2
            if (s.env >= 2 && s.ageing < 3 && s.acne < 2) {
                return this.getProtocol("am_protocol");
            }

            // Fallback (if no strict match) - usually AM or Anti-Ageing depending on profile
            // Default to AM Protocol for safety/prevention
            return this.getProtocol("am_protocol");
        }

        getProtocol(id) {
            return this.config.protocols.find(p => p.id === id);
        }
    }

    // --- 3. UI RENDERER ---
    // const KLAVIYO_LIST_ID = "YOUR_LIST_ID"; // Use config.settings.klaviyo_list_id instead

    class QuizUI {
        constructor(engine, selectors) {
            this.engine = engine;
            this.selectors = selectors;

            this.drawer = document.querySelector(selectors.drawer);
            this.content = document.querySelector(selectors.content);
            this.progressBar = document.querySelector(selectors.progressBar);
            this.nextBtn = document.querySelector(selectors.nextBtn);
            this.prevBtn = document.querySelector(selectors.prevBtn);
            // Select ALL close triggers (The X button, the Overlay, and the Backdrop)
            this.closeBtns = document.querySelectorAll('.close-btn, .quiz-overlay, .quiz-backdrop, #close-quiz-btn');
            this.startBtn = document.querySelector(selectors.startBtn);
        }

        init() {
            this.bindEvents();
        }

        bindEvents() {
            // 1. Internal "Start" Button
            if (this.startBtn) {
                this.startBtn.addEventListener('click', () => {
                    this.openQuiz();
                });
            }

            // 2. GLOBAL TRIGGER
            document.addEventListener('click', (e) => {
                if (e.target.matches('.open-skin-quiz') || e.target.closest('.open-skin-quiz')) {
                    e.preventDefault();
                    this.openQuiz();
                }
            });

            // 3. AUTO-OPEN
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('open-quiz') === 'true') {
                setTimeout(() => this.openQuiz(), 500);
            }

            // 4. Close Triggers (Iterate all found)
            this.closeBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    this.closeQuiz();
                });
            });

            this.nextBtn.addEventListener('click', () => {
                const currentQ = this.engine.getCurrentQuestion();
                if (this.engine.currentStep < this.engine.totalSteps) {
                    if (!this.engine.answers[currentQ.id]) {
                        alert("Please select an option to move forward.");
                        return;
                    }
                }

                if (this.engine.currentStep < this.engine.totalSteps - 1) {
                    this.engine.nextStep();
                    this.renderStep();
                } else {
                    this.renderEmailGate();
                }
            });

            this.prevBtn.addEventListener('click', () => {
                this.engine.prevStep();
                this.renderStep();
            });

            this.content.addEventListener('click', (e) => {
                if (e.target.classList.contains('option-btn')) {
                    const questionId = e.target.dataset.questionId;
                    const optionId = e.target.dataset.optionId;
                    this.engine.answerQuestion(questionId, optionId);

                    document.querySelectorAll('.option-btn').forEach(btn => btn.classList.remove('selected'));
                    e.target.classList.add('selected');

                    // Auto-advance
                    this.handleAutoAdvance();
                }
            });
        }

        handleAutoAdvance() {
            setTimeout(() => {
                if (this.engine.currentStep < this.engine.totalSteps - 1) {
                    this.engine.nextStep();
                    this.renderStep();
                } else {
                    this.renderEmailGate();
                }
            }, 400); // 400ms delay for visual feedback
        }

        openQuiz() {
            this.drawer.setAttribute('aria-hidden', 'false');
            this.renderStep();
        }

        closeQuiz() {
            this.drawer.setAttribute('aria-hidden', 'true');
        }

        updateProgress() {
            const pct = ((this.engine.currentStep + 1) / (this.engine.totalSteps + 1)) * 100; // +1 for Email step
            this.progressBar.style.width = `${pct}%`;
        }

        renderStep() {
            const question = this.engine.getCurrentQuestion();

            const html = `
                <div class="question-container fade-in">
                    <span class="step-label">Step ${this.engine.currentStep + 1} of ${this.engine.totalSteps}</span>
                    <h2 class="question-text">${question.text}</h2>
                    <div class="options-grid">
                        ${question.options.map(opt => {
                const isSelected = this.engine.answers[question.id] === opt.id ? 'selected' : '';
                return `
                            <button class="option-btn ${isSelected}"
                                    data-question-id="${question.id}"
                                    data-option-id="${opt.id}">
                                ${opt.text}
                            </button>
                            `;
            }).join('')}
                    </div>
                </div>
            `;

            this.content.innerHTML = html;

            this.prevBtn.disabled = this.engine.currentStep === 0;
            this.prevBtn.textContent = "←"; // Arrow
            this.prevBtn.style.display = 'inline-block';
            // Next button is hidden via CSS

            this.updateProgress();
        }

        renderEmailGate() {
            // Hide progress bar or set to 90%?
            this.progressBar.style.width = '90%';

            const html = `
                <div class="email-capture-container fade-in">
                    <span class="step-label">Almost There</span>
                    <h2 class="question-text" style="margin-bottom: 24px;">Unlock your full skin analysis.</h2>
                    <p style="color: #666; margin-bottom: 32px;">Enter your email to save your profile and reveal your prescribed protocol.</p>

                    <div class="email-input-group">
                        <label for="user-email">Email Address</label>
                        <input type="email" id="user-email" class="email-input" placeholder="you@example.com" required>
                    </div>

                    <div style="text-align: right;">
                         <button id="submit-email-btn" class="btn btn-primary" style="width: 100%;">Reveal My Protocol</button>
                    </div>

                    <p class="disclaimer-text">
                        By continuing, you agree to receive expert skin tips and updates from Aliangé. You can unsubscribe at any time.
                    </p>
                </div>
            `;

            this.content.innerHTML = html;
            this.prevBtn.style.display = 'none'; // No going back from email gate? Or maybe allowed. Let's hide to force forward.
            this.nextBtn.style.display = 'none';

            // Bind Submit
            const btn = document.getElementById('submit-email-btn');
            const input = document.getElementById('user-email');

            btn.addEventListener('click', () => {
                this.handleEmailSubmit(input.value);
            });

            // Allow Enter key
            input.addEventListener('keypress', (e) => {
                if (e.key === 'Enter') this.handleEmailSubmit(input.value);
            });
        }

        handleEmailSubmit(email) {
            if (!email || !email.includes('@')) {
                alert("Please enter a valid email address.");
                return;
            }

            const listId = this.engine.config.settings.klaviyo_list_id || "TBxECh";

            // Determine prescribed protocol BEFORE sending to Klaviyo
            const result = this.engine.determineResult();
            const scores = this.engine.scores; // Already calculated by determineResult

            // 1. Identify (Profile + Protocol on Profile)
            const profileData = {
                $email: email,
                $source: 'Skin Quiz',
                Prescribed_Protocol: result.title,
                Skin_Feel: this.engine.answers['baseline_skin'],
                Primary_Concern: this.engine.answers['primary_priority'],
                Reactivity: this.engine.answers['tolerance_reactivity'],
                Barrier_Integrity: this.engine.answers['barrier_integrity'],
                Ageing_Signs: this.engine.answers['structural_ageing'],
                Congestion: this.engine.answers['congestion_pattern'],
                Pigmentation: this.engine.answers['pigmentation'],
                Environment: this.engine.answers['environment']
            };

            // 2. Track Event (For Flow Triggers)
            const eventData = {
                Prescribed_Protocol: result.title,
                Protocol_Handle: result.handle,
                Protocol_Price: result.price,
                Score_Barrier: scores.barrier,
                Score_Sensitivity: scores.sensitivity,
                Score_Pigment: scores.pigment,
                Score_Ageing: scores.ageing,
                Score_Acne: scores.acne,
                Score_Tolerance: scores.tolerance
            };

            // Support both modern Klaviyo API and legacy _learnq
            if (window.klaviyo) {
                // Modern Klaviyo API (newer snippet versions)
                window.klaviyo.identify(profileData);
                window.klaviyo.track('Completed Skin Quiz', eventData);
                console.log("Klaviyo: identify + track sent via modern API");
            } else if (window._learnq) {
                // Legacy Klaviyo API
                window._learnq.push(['identify', profileData]);
                window._learnq.push(['track', 'Completed Skin Quiz', eventData]);
                console.log("Klaviyo: identify + track sent via legacy API");
            } else {
                console.warn("Klaviyo: Neither window.klaviyo nor window._learnq found");
            }

            // 3. Direct List Subscription
            const formData = new FormData();
            formData.append('g', listId);
            formData.append('email', email);
            formData.append('$fields', '$source');
            formData.append('$source', 'Skin Quiz');

            fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
                method: 'POST',
                body: formData
            }).then(() => {
                console.log("Klaviyo Subscription Request Sent");
            }).catch(e => console.warn("Klaviyo Sub Error", e));

            // Move to Results immediately (don't block on network)
            this.showResults();
        }

        /**
         * Fetches real product data from Shopify and renders the result
         */
        showResults() {
            const result = this.engine.determineResult();

            // Show Loading State
            this.content.innerHTML = `
                <div style="display:flex; justify-content:center; align-items:center; height:300px;">
                    <div class="fade-in" style="text-align:center;">
                        <span style="font-size: 24px;">Analysing your skin...</span>
                    </div>
                </div>
            `;
            this.progressBar.style.width = '100%';
            this.nextBtn.style.display = 'none';
            this.prevBtn.style.display = 'none';

            // Fetch Real Product Data
            const handle = result.handle;

            fetch(`/products/${handle}.js`)
                .then(res => {
                    if (!res.ok) throw new Error("Product not found");
                    return res.json();
                })
                .then(product => {
                    this.renderResultCard(result, product);
                })
                .catch(err => {
                    console.warn("Product fetch failed", err);
                    // Fallback to static config data if fetch fails
                    this.renderResultCard(result, null);
                });
        }

        renderResultCard(configResult, shopifyProduct) {
            // Merge Data: Prefer Shopify Data if available
            const title = shopifyProduct ? shopifyProduct.title : configResult.title;
            const price = shopifyProduct ? (shopifyProduct.price / 100).toFixed(2) : configResult.price;
            const imageHtml = shopifyProduct ? `<img src="${shopifyProduct.featured_image}" alt="${title}" style="width:100%; border-radius: 4px; margin-bottom: 16px;">` : '';
            // Store variant ID for Cart Add
            const variantId = shopifyProduct ? shopifyProduct.variants[0].id : configResult.handle; // Fallback to handle if fetch failed, but addToCart handles that.

            // Note: We update the handle in the configResult purely for passing to addToCart
            if (shopifyProduct) configResult.variantId = variantId;

            const html = `
                <div class="result-container fade-in">
                    <span class="eyebrow" style="color: grey; font-size: 0.9em; letter-spacing: 1px;">S K I N &nbsp; A N A L Y S I S</span>
                    
                    <h2 style="font-size: 2.2em; margin: 16px 0;">${title}</h2>
                    
                    ${imageHtml}

                    <p style="font-size: 1.1em; color: #555; margin-bottom: 32px;">${configResult.description}</p>
                    
                    <div class="protocol-card" style="border: 1px solid #eee; padding: 24px; text-align: center;">
                        <h3 style="margin-bottom: 8px;">${title}</h3>
                        <p style="font-weight: bold; font-size: 1.2em;">$${price} AUD</p>
                        <button id="add-to-cart-action" class="btn btn-primary" style="margin-top: 16px; width: 100%;" data-handle="${configResult.handle}">Learn More</button>
                    </div>

                    <div style="margin-top: 32px; text-align: center;">
                        <a href="#" onclick="location.reload()" style="color: #999; text-decoration: underline; font-size: 0.9em;">Retake Analysis</a>
                    </div>
                </div>
            `;

            this.content.innerHTML = html;

            // Bind Learn More → navigate to PDP
            const learnMoreBtn = document.getElementById('add-to-cart-action');
            if (learnMoreBtn) {
                learnMoreBtn.addEventListener('click', () => {
                    window.location.href = '/products/' + configResult.handle;
                });
            }
        }

        /**
         * Shopify Cart API Integration
         */
        addToCart(result) {
            console.log("Adding to Cart:", result);
            const submitBtn = document.getElementById('add-to-cart-action');
            if (submitBtn) submitBtn.textContent = 'Loading...';

            const payload = {
                items: [{
                    id: result.variantId || result.handle, // Liquid usually expects ID, but some themes handle handle? No, typically ID. 
                    // However, since we are using Handles in the config, we might need to rely on the liquid section to render IDs or fetch them.
                    // WAIT. The config has Handles. Shopify AJAX API requires Variant IDs for `id`. 
                    // PROPOSAL: The `window.AliangeSettings` should map to variant IDs, or we assume the `handle` IS the ID for this prototype?
                    // User check: "how do I make sure that their email is captured... I need this to integrate into a Klaviyo list". 
                    // User didn't specify Variant IDs.
                    // Issue: Handles passed to /cart/add.js won't work directly if using the `items` array format usually. 
                    // Actually, you usually need to POST to `/cart/add.js` with `id` (variant ID). 
                    // If we only have handles, we might need to fetch the product JSON first to get the first variant ID?
                    // OR, we can assume the user will configure Variant IDs in the `window.AliangeSettings`.

                    // Let's look at the Integration Guide. 
                    // "Map the protocol results to Shopify Product Handles." (Type: product).
                    // In Liquid, `section.settings.product_essential` returns the *Product Handle*? No, it returns the Product Object in Liquid Drop, but in `{{ }}` it often outputs the grid handle.
                    // Actually, for the JS to work, we need Variant IDs.

                    // I will update the code to try to fetch the product by handle to get the ID if needed, OR 
                    // simpler: assume `result.handle` might be replaced by `result.id` if settigns provided IDs.
                    // But `window.AliangeSettings` in the guide maps `products` to handles?
                    // Let's refine the JS to be robust. 
                    // "Native Cart Integration" usually implies getting a Variant ID.

                    // STRATEGY: 
                    // 1. Try to add directly.
                    // 2. But first, let's look at how to get the ID from a handle in JS storefront? 
                    // Fetch `/products/<handle>.js`.

                    // I will implement a helper: `fetchVariantId(handle)`.
                    // Then add to cart.

                    // This is safer.

                    quantity: 1,
                    properties: {
                        'Prescribed via': 'Skin Analysis Quiz'
                    }
                }]
            };

            // If we have an integer ID (from overrides), use it directly.
            // If it looks like a handle (string), fetch it first.
            let id = result.handle;

            // Helper to add
            const executeAdd = (variantId) => {
                fetch(window.Shopify ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [{
                            id: variantId,
                            quantity: 1,
                            properties: { 'Prescribed via': 'Skin Analysis Quiz' }
                        }]
                    })
                })
                    .then(response => {
                        if (response.ok) return response.json();
                        throw new Error('Network response was not ok.');
                    })
                    .then(data => {
                        console.log("Added:", data);
                        window.location.href = '/products/' + result.handle;
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        alert("Unable to add to cart. Please try again.");
                        if (submitBtn) submitBtn.textContent = 'Add Protocol to Cart';
                    });
            };

            // If handle is numeric (ID), go. Else fetch product.
            if (String(id).match(/^\d+$/)) {
                executeAdd(id);
            } else {
                // Fetch product data to get first variant ID
                fetch(`/products/${id}.js`)
                    .then(res => res.json())
                    .then(product => {
                        const variantId = product.variants[0].id;
                        executeAdd(variantId);
                    })
                    .catch(err => {
                        console.error("Could not resolve product handle:", id);
                        // Fallback: Just try sending the handle (some apps intercept)? Or just alert.
                        // For prototype: Alert the payload so they can see it works "theoretically".
                        alert(`SHOP INTEGRATION:\n\nTried to fetch product: ${id}\n\n(This works when hosted on Shopify)`);
                        if (submitBtn) submitBtn.textContent = 'Add Protocol to Cart';
                    });
            }
        }
    }

    // --- 4. INITIALIZATION ---
    document.addEventListener('DOMContentLoaded', () => {
        // Shopify Integration: Override Config if AliangeSettings exists
        if (window.AliangeSettings) {
            console.log("Aliangé Quiz: Loading Shopify Settings...");

            // 1. Override Product Handles
            if (window.AliangeSettings.products) {
                QUIZ_CONFIG.protocols.forEach(p => {
                    // Map ID (e.g., 'the_protocol') to variable name in settings (e.g., 'the_protocol')
                    // Note: Settings keys match IDs roughly but let's be safe.
                    // Settings: essential, the_protocol, pm, anti_ageing, acne, am
                    // Protocol IDs: essential, the_protocol, pm_protocol, anti_ageing, acne, am_protocol

                    let settingKey = p.id;
                    if (p.id === 'pm_protocol') settingKey = 'pm';
                    if (p.id === 'am_protocol') settingKey = 'am';

                    if (window.AliangeSettings.products[settingKey]) {
                        p.handle = window.AliangeSettings.products[settingKey];
                    }
                });
            }

            // 2. Override Klaviyo List
            if (window.AliangeSettings.klaviyoListId) {
                QUIZ_CONFIG.settings.klaviyo_list_id = window.AliangeSettings.klaviyoListId;
            }
        }

        const engine = new QuizEngine(QUIZ_CONFIG);
        const ui = new QuizUI(engine, {
            drawer: '#quiz-drawer',
            content: '#quiz-content',
            progressBar: '#progress-bar',
            nextBtn: '#next-btn',
            prevBtn: '#prev-btn',
            closeBtn: '#close-quiz-btn',
            startBtn: '#start-quiz-btn'
        });

        ui.init();

        // Expose for debugging
        window.AliangeQuiz = { engine, ui };
    });

})();
